import { render } from "./TheMain.vue?vue&type=template&id=d025f748"
import script from "./TheMain.vue?vue&type=script&lang=js"
export * from "./TheMain.vue?vue&type=script&lang=js"

import "./TheMain.vue?vue&type=style&index=0&id=d025f748&lang=css"

import exportComponent from "C:\\Spinnov\\ace-challenge-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__